export default __webpack_public_path__ + "2205217c80d0721272689d9e8e57fce6.svg";